module.exports = __webpack_public_path__ + "media/images/icons/outlined/home-eb0d26bd7daed6f1f0835c09e68b1018.svg";